<template>
  <td v-if="renderCell" class="checkbox-template text-center" :class="[{ editable: isEditable }, className]" @click="$emit('cellclick', { dataItem, field, event: $event })">
    <input ref="cellinput" class='k-checkbox' type='checkbox' indeterminate :disabled="!isEditable" :checked="localValue" @change="$emit('change', null, $event)" />
  </td>
  <td v-else-if="renderArrow" :key="`g-${columnIndex}`" class="k-group-cell" />
  <td v-else-if="renderGroup" key="g-colspan" class="checkbox-template" :colSpan="columnsCount - columnIndex">
    <p class="k-reset">
      <a @click="$emit('click', $event, dataItem, expanded)" tabIndex="-1" href="#" :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'" />
      {{ groupHeader }}
    </p>
  </td>
</template>
<script>
import { i18n } from '@/i18n'
import getNestedValue from '@/services/functions/getNestedValue'
import { discard } from '@/services/functions/preserve&discard'
import NULL from '@/constants/NULL'

export default {
  name: 'checkbox-template',
  props: {
    tableId: [String, Number],
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    type: {
      type: String,
      default: 'Text'
    },
    curEditField: [String, null],
    editType: {
      type: [String, Boolean],
      default: 'row'
    },
    editField: {
      type: String,
      default: 'inEdit'
    },
    extraparams: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      localValue: ''
    }
  },
  mounted () {
    this.localValue = this.value
    if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
      this.$refs.cellinput.focus()
    }
  },
  watch: {
    value: function (value, oldValue) {
      if (value !== oldValue) {
        this.localValue = value
      }
    },
    isEditable: function (value, oldValue) {
      if (value && value !== oldValue) {
        this.$nextTick(() => {
          if (this.isEditable && this.curEditField === this.field && this.$refs.cellinput) {
            this.$refs.cellinput.focus()
          }
        })
      }
    }
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      // return returnValue && this.dataItem[this.field]
      return returnValue && this.dataItem[this.field] !== undefined
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    },
    renderGroup () {
      return this.columnIndex <= this.level
    },
    inEdit: function () {
      return getNestedValue(this.editField, this.dataItem) === true
    },
    value: function () {
      const value = getNestedValue(this.field, this.dataItem)
      return value === NULL ? false : !!value
    },
    groupHeader () {
      const value = this.value
      if (this.rowType === 'groupHeader') {
        const template = this.extraparams.groupHeaderTemplate
        if (typeof template === 'function') {
          return template(this.dataItem, { value, ...discard([template.name], this.extraparams) })
        }
      }
      return `${this.extraparams.title}: ${value ? i18n.t('app.yes') : i18n.t('app.no')}`
    },
    editable: function () {
      return !!this.extraparams.editable
    },
    isCellEditable: function () {
      return this.editType === 'cell'
    },
    isEditable: function () {
      return this.editable && this.inEdit && (!this.isCellEditable || this.curEditField === this.field)
    }
  }
}
</script>
